































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ReturnFeeGuide extends Vue {
  @Prop() private onNegativeClick!: () => void;
}
